import Vue from 'vue'
import LoadingPlaceholder from '../components/loading/LoadingPlaceholder.vue'
const loadingGif = require('../assets/loading-gif/loading.svg')

let intervals = {}
/**
 * @param {HTMLElement} target
 * @param {Array<string>} messages
 */
const appendMessageToLoading = (target, messages) => {
  const length = messages.length
  if (length === 0) {
    return
  }
  const translatedMessages = messages.map(message => Vue.i18n.translate(message))

  const span = document.createElement('span')
  span.id = 'span-' + target.id

  span.style.cssText = `
    position: relative;
    display: block;
    color: #13556A;
    font-family: 'Inter', sans-serif;
font-weight: 700;
    font-size: 25px;
    top: 65%;
    width: 100%;
    text-align: center;
    z-index: 1000000;`

  target.appendChild(span)

  let counter = 1
  span.innerText = translatedMessages[0]
  intervals[span.id] = setInterval(() => {
    span.innerText = translatedMessages[counter % length]
    counter++
  }, 2500)
}

/**
 * @param {string} idGrid
 * @param {Array<string>} messages
 */
const startTreeGridLoading = (idGrid, messages = ['geral.loading.andamento', 'geral.loading.preparandoGrid'], isScrollable = true) => {
  let element = document.querySelector(idGrid)
  if (element) {
    if (document.getElementById(`botoesExportacoes`)) {
      document.getElementById(`botoesExportacoes`).style.display = 'none'
    }

    for (const child of element.children) {
      child.remove()
    }

    element.style.background = 'url(' + loadingGif + ') 50% 50% no-repeat'
    element.style.backgroundSize = '100px'
    element.style.cursor = 'wait'

    appendMessageToLoading(element, messages)

    if (isScrollable) {
      setTimeout(() => {
        element.scrollIntoView({ behavior: 'smooth' })
      }, 200)
    }
  }
}

const stopTreeGridLoading = (idGrid) => {
  let element = document.querySelector(idGrid)
  if (element) {
    if (document.getElementById(`botoesExportacoes`)) {
      document.getElementById(`botoesExportacoes`).style.display = 'block'
    }

    element.style.background = 'inherit'
    element.style.cursor = 'initial'
    const spanMessages = element.querySelector('#span-' + element.id)
    if (spanMessages) {
      if (intervals[spanMessages.id]) {
        clearInterval(intervals[spanMessages.id])
        delete intervals[spanMessages.id]
      }
      spanMessages.remove()
    }
    setTimeout(() => {
      element.scrollIntoView({ behavior: 'smooth' })
    }, 200)
  }
}

const generateLoadingRows = number => Array(number).fill(LoadingPlaceholder, 0, number)

export {
  startTreeGridLoading,
  stopTreeGridLoading,
  generateLoadingRows
}



// WEBPACK FOOTER //
// ./client/utils/grid-load-transition.js